<mat-form-field class="example-full-width">
    <mat-label>{{ _label }}</mat-label>
    <input type="text" matInput [formControl]="myControl" [matAutocomplete]="auto" required="_isRequired" (blur)="checkValue()">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
      @for (option of filteredOptions | async; track option) {
        <mat-option [value]="option" (onSelectionChange)="onValueUpdated($event)">{{option.description}}</mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
